import { render, staticRenderFns } from "./MassSendCustomerDetail.vue?vue&type=template&id=3b4285f1&"
import script from "./MassSendCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./MassSendCustomerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4285f1')) {
      api.createRecord('3b4285f1', component.options)
    } else {
      api.reload('3b4285f1', component.options)
    }
    module.hot.accept("./MassSendCustomerDetail.vue?vue&type=template&id=3b4285f1&", function () {
      api.rerender('3b4285f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/MassSendCust/MassSendCustomerDetail.vue"
export default component.exports